const appVersion = require('../../package.json').version;

export const environment = {
  production: true,
  version: appVersion
};
